module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAOVBMVEUAAAAWsToWsTr///9dwW/1+/aM0Jcztk7g8uO/5MTr9uym2q5uxn3W7dl+y4tKvF/K6M+z37qa1aPYmHFUAAAAAnRSTlMAgJsrThgAAAD3SURBVEjHldPdrgIhDATgObYsC+yPnvd/WLUb0xiwZOaCq35kIIAbmz/wArwAK8ZEH6HAQKQ1RwK8wA+RfwuMxZK0F2OSk2xvIQY70RMbThqIjqiaabHAV6tkZiLQtbI1EEZC46In25Z746InRxVJi5s6FE5sprU9ezd1MSabFLukUiatnNzTJURK3MqJlEuU1Yy6iImmcsurLFErJ9WqvDd/iEbCSZP2eTN7KJzkevXJazqnAp+fJfftXKocLgJiOXd5paqLmFj0vx3zczjxzAV4AV6AF+AFeAFegBfgBXgBXoAX4AV4AV6AF+AFeAFegBfgBXjxBN/6DSG9vEEQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif_comments.png
// module id = 557
// module chunks = 1 7 8